import { useCallback } from 'react';
import { usePortletTranslations } from 'js/components/system/Portlet';

import { formatTimeLimit } from '../helpers';
import { UNLIMITED, LIMIT_TYPES } from '../constants';

export const useGetPendingLimitText = () => {
    const t = usePortletTranslations();

    return useCallback(limit => {
        const { pendingLabel, limitType, limit: value } = limit;

        if (value === UNLIMITED) {
            return `${t(pendingLabel)} ´${t('date.unlimited')}´`;
        } else if (limitType === LIMIT_TYPES.LOGIN_COUNT) {
            return `${t(pendingLabel)} ${value}`;
        }

        return `${t(pendingLabel)} ${formatTimeLimit(value, t)}`;
    }, [t]);
};
